import PropTypes from 'prop-types'
import { useContext, useMemo } from 'react'
import * as FEATURES from '../../../../constants/features'
import * as SETTINGS from '../../../../constants/settings'
import { SiteConfigContext } from '../../../../context/siteConfigContext'
import { toastSuccess } from '../../../../utils/toast'
import UploadImages from '../../../Forms/common/UploadImages'
import Tooltip from '../../../Utilities/Tooltip'

const Images = () => {
  const {
    [SETTINGS.FEATURES.key]: enabledFeatures,
    [SETTINGS.IMAGES.key]: images,
    updateSetting
  } = useContext(SiteConfigContext)

  const preStreamEnabled = useMemo(
    () => enabledFeatures && enabledFeatures[FEATURES.PRESTREAM],
    [enabledFeatures]
  )

  const setImage = async (type, image, reason) => {
    const copy = { ...images }
    copy[type] = image
    await updateSetting(SETTINGS.IMAGES, copy)
    toastSuccess(`Image/s ${reason} successfully!`)
  }

  const updateImage = (key) => (image) => {
    setImage(key, image, 'Saved')
  }

  const handleDelete = (key) => () => {
    setImage(key, '', 'Deleted')
  }

  return (
    <>
      <div className="flex items-center">
        <h2 className="mr-3">Image Upload</h2>
        <Tooltip>
          Manage your site&apos;s branding images: update light/dark logos and
          the offline stream image.
        </Tooltip>
      </div>

      <div className="w-full divide-y divide-neutral-200 dark:divide-neutral-700 flex flex-col gap-4">
        <ImageSection
          title="Logo (Light)"
          image={images.logo}
          handleDelete={handleDelete('logo')}
          returnImage={updateImage('logo')}
        />
        <ImageSection
          title="Logo (Dark)"
          image={images.logoDark}
          handleDelete={handleDelete('logoDark')}
          returnImage={updateImage('logoDark')}
          dark
        />
        <ImageSection
          title="Stream Offline"
          image={images.offline}
          handleDelete={handleDelete('offline')}
          returnImage={updateImage('offline')}
        />
        {preStreamEnabled && (
          <ImageSection
            title="Stream Starting"
            image={images.starting}
            handleDelete={handleDelete('starting')}
            returnImage={updateImage('starting')}
          />
        )}
      </div>
    </>
  )
}

const ImageSection = ({ title, image, handleDelete, returnImage, dark }) => {
  return (
    <div className="w-full p-2 xl:p-5 flex flex-col xl:grid xl:grid-cols-[200px_1fr_1fr_auto] gap-4 items-start">
      <h2>{title}</h2>
      {image ? (
        <img
          src={image}
          alt="Image"
          className={`${dark ? 'bg-black' : 'bg-white'} p-5 w-full`}
        />
      ) : (
        <div className="w-full bg-black p-5">
          <p className="text-gray-500">No image uploaded</p>
        </div>
      )}
      <div className="w-full">
        <UploadImages returnImages={returnImage} single />
      </div>
      <button onClick={handleDelete} className="text-xs button-cancel w-fit">
        Remove
      </button>
    </div>
  )
}

ImageSection.propTypes = {
  title: PropTypes.string.isRequired,
  image: PropTypes.string,
  handleDelete: PropTypes.func.isRequired,
  returnImage: PropTypes.func.isRequired
}

export default Images
